import { render } from "./XIconSolidShield.vue?vue&type=template&id=3103012c"
import script from "./XIconSolidShield.vue?vue&type=script&lang=js"
export * from "./XIconSolidShield.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidShield.vue"]])

export default __exports__